<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-logout"
    :width="props.width"
    :height="props.height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
    ></path>
    <path d="M9 12h12l-3 -3"></path>
    <path d="M18 15l3 -3"></path>
  </svg>
</template>

<script lang="ts" setup>
export interface IconProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
